module.exports = __webpack_public_path__ + "img/preview-mobile.7cad66a0.svg";